var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyebrows3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new_eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyebrows_x5F_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M370.7,247.3c-1.5,1.7-3.8,3.2-0.8,4.3c2.4,0.9,5.2-0.7,7.1-1.7c4.3-2.3,8.7-4.6,12.9-6.8 c8.9-4.4,17.9-8.5,28.1-8.2c6.5,0.2,12.9,1.3,18.8,3.9c-6.4-6.8-19.5-8-28.3-7.4c-9.9,0.7-19.3,3.2-27.9,8.5 c-3.1,1.9-6.7,3.8-9,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M343.6,247.3c1.5,1.7,3.8,3.2,0.8,4.3c-2.4,0.9-5.2-0.7-7.1-1.7c-4.3-2.3-8.7-4.6-12.9-6.8 c-8.9-4.4-17.9-8.5-28.1-8.2c-6.5,0.2-12.9,1.3-18.8,3.9c6.4-6.8,19.5-8,28.3-7.4c9.9,0.7,19.3,3.2,27.9,8.5 c3.1,1.9,6.7,3.8,9,6.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyebrows3D);
export default __webpack_public_path__ + "static/media/eyebrows_3d.b9207b5a0eebda47b69d15c475e3db6f.svg";
export { ForwardRef as ReactComponent };